/**
 * Sorts announcements ("oproepen") newest-first by their start date.
 *
 * Single source of truth so every list that shows announcements — the student's
 * own profile tab, the company-facing student profile, the browse page and the
 * student-applications view — orders them identically.
 *
 * Returns a new array; the input is left untouched. Missing/empty start dates
 * (including .NET `DateTime.MinValue`) sort to the bottom.
 */
export function sortAnnouncementsNewestFirst<
  T extends { startDateTime?: string | null },
>(items: readonly T[]): T[] {
  return [...items].sort(
    (a, b) =>
      new Date(b.startDateTime ?? 0).getTime() -
      new Date(a.startDateTime ?? 0).getTime(),
  );
}
